import apiMiddleware from "../api/apiMiddleware";

// List all attraction supplier masters with pagination
export const list = async (page = 1) => {
  const response = await apiMiddleware.get(
    `/attraction-supplier-master?page=${page}`
  );
  return response.data;
};

// Add new attraction supplier master
export const add = async (formData) => {
  const response = await apiMiddleware.post(
    "/attraction-supplier-master",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

// Update existing attraction supplier master
export const update = async (id, formData) => {
  const response = await apiMiddleware.post(
    `/attraction-supplier-master/${id}?_method=PUT`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return response.data;
};

// Delete attraction supplier master
export const remove = async (id) => {
  const response = await apiMiddleware.delete(`/attraction-supplier-master/${id}`);
  return response.data;
};


